export const engagementPresetLandingPageTemplatesDataId = "/engagement/preset_landing_page_templates_data/:id";
